import * as AudioFormat from "../interfaces/IAudioFormat";
import { WavFormat } from "./WavFormat";

export function CreateAndInitializeAudioFormat(formatProps: AudioFormat.IFormatProperties): AudioFormat.IAudioFormat {
    let format: AudioFormat.IAudioFormat = null;
    switch (formatProps.format) {
        case AudioFormat.SupportedFormats.wav:
            format = new WavFormat();
            format.InitializeEncoder(formatProps);
            break;
        default:
            throw new Error("Unknown format: " + formatProps.format);
    }

    return format;
}
